import React, { useState, useEffect } from "react";
import "./ListDivisions.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { divisionReducer } from "../../Redux/store";
import SlidingPane from "react-sliding-pane";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

// import Backdrop from "@mui/material/Backdrop";
// import CircularProgress from "@mui/material/CircularProgress";

import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";


function ListDivision() {
  // Dispatch function

  const dispatch = useDispatch();
  const [buData, setBuData] = useState([]);

  //Permission for Roles
  const Add_Permission = useSelector((state) => state.AccessTocken.Add_Permission);
  const Edit_Permission = useSelector((state) => state.AccessTocken.Edit_Permission);
  const Delete_Permission = useSelector((state) => state.AccessTocken.Delete_Permission);
  const View_Permission = useSelector((state) => state.AccessTocken.View_Permission);
  // const Download_Permission = useSelector((state) => state.AccessTocken.Download_Permission);

  //API related selectors
  const tocken = useSelector((state) => state.AccessTocken.accessTocken);
  const msToken = useSelector((state) => state.AccessTocken.o365token);
  const token = tocken ? tocken : msToken;

  //division Edit related selectors
  const division_id = useSelector((state) => state.division.division_id);
  const division_name = useSelector((state) => state.division.division_name);
  // const division_status = useSelector(
  //   (state) => state.division.division_status
  // );

  //Add Division and Edit Division  related selectors
  const division_edit = useSelector((state) => state.division.division_edit);
  const division_IsPane = useSelector((state) => state.division.divisionIsPane);
  const adddivision_IsPane = useSelector((state) => state.division.adddivisionIsPane);
  const division_Buid = useSelector((state) => state.division.division_Buid);

  //state hook for listDivision  API's
  const [ListDivision, setListDivision] = useState([]);
  const [divisionCount, setDivisionCount] = useState(null);

  //state hook for Add Division API's
  const [newDivision, setNewDivision] = useState(null);
  const [newStatus, setNewStatus] = useState(null);
  const [newId, setNewId] = useState(null);

  //state hook for Edit Division  API's
  const [divisionId, setDivisionId] = useState(null);
  const [divisionName, setDivisionName] = useState(null);
  const [Editstatus, setEditStatus] = useState("");
  const [businessunitData, setBusinessunitData] = useState("");
  const [businessunitName, setBusinessunitName] = useState("");
  const [statusName, setStatusName] = useState("");

  // filtering
  const [Divfilter, setDivfilter] = useState("");
  const [DivisionselData, setDivisionselData] = useState("");

  const [isFiltered, setIsFiltered] = useState(false);
  const [isFilterIReset, setIsFilterIReset] = useState(false);

  const [dummyDivfilter, setDummyDivfilter] = useState("");
  const [dummyDivisionselData, setDummyDivisionselData] = useState("");

  const division_filter = useSelector((state) => state.division.division_filter);
  const [divisionData, setdivisionData] = useState([]);

  // dependency
  const [IsDependent, setIsDependent] = useState(false);
  var opt = null;

  const [tableHeight, setTableHeight] = useState(false);

  //Add content pop up
  const [popUp, setPopUp] = useState(false);

  //spinner for API 
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  // for showing 400 error msg
  const [errMsg, setErrMsg] = useState("");


  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    // height: 300,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };

  //Header for API's
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  //Pagenation
  const [index1_pagenation, setIndex1_pagenation] = useState(1);
  const [index2_pagenation, setIndex2_pagenation] = useState(2);
  const [index3_pagenation, setIndex3_pagenation] = useState(3);
  const [index4_pagenation, setIndex4_pagenation] = useState(4);
  const [noOfPages, setNoOfPages] = useState(null);
  const [pageSelected, setPageSelected] = useState(1);
  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  const onPage = {
    cursor: "pointer",
    backgroundColor: "RGB(200, 200, 200)",
    scale: "1.2",
    height: "25px",
  };
  const notOnPage = { cursor: "pointer", scale: "1" };

  const leftArrow = () => {
    if (index1_pagenation !== 1) {
      setIndex1_pagenation(index1_pagenation - 1);
      setIndex2_pagenation(index2_pagenation - 1);
      setIndex3_pagenation(index3_pagenation - 1);
      setIndex4_pagenation(index4_pagenation - 1);
    }
    setPageSelected(pageSelected - 1);
    pagenationAPi(pageSelected - 1, DivisionselData, Divfilter);
  };

  const rightArrow = () => {
    if (noOfPages >= 4) {
      if (index4_pagenation !== noOfPages) {
        setIndex1_pagenation(index1_pagenation + 1);
        setIndex2_pagenation(index2_pagenation + 1);
        setIndex3_pagenation(index3_pagenation + 1);
        setIndex4_pagenation(index4_pagenation + 1);
      }
    }
    setPageSelected(pageSelected + 1);
    pagenationAPi(pageSelected + 1, DivisionselData, Divfilter);
  };

  const leftEndArrow = () => {
    setIndex1_pagenation(1);
    setIndex2_pagenation(2);
    setIndex3_pagenation(3);
    setIndex4_pagenation(4);
    pagenationAPi(1, DivisionselData, Divfilter);
  };

  const rightEndArrow = () => {
    if (noOfPages > 4) {
      setIndex1_pagenation(noOfPages - 3);
      setIndex2_pagenation(noOfPages - 2);
      setIndex3_pagenation(noOfPages - 1);
      setIndex4_pagenation(noOfPages);
    } else if (noOfPages <= 4) {
      setIndex1_pagenation(1);
      setIndex2_pagenation(2);
      setIndex3_pagenation(3);
      setIndex4_pagenation(4);
    }
    pagenationAPi(noOfPages, DivisionselData, Divfilter);
  };

  const pagenationAPi = async (pageNo, TargetColomn, keyWord) => {
    if (!isFiltered) {
      setPageSelected(pageNo);
      dispatch(sidebarReducer.apiLoad(true));
      await axios
        .get(`division/list/?page=${pageNo}&limit=${listLimit}`, options)
        .then((response) => {
          if (response.status === 200) {
            dispatch(sidebarReducer.apiLoad(false));
            setListDivision(response.data.data.rows);
          } else if (response.status !== 200) {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          }
        })
        .catch((err) => {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        });
    } else if (isFiltered) {
      dispatch(sidebarReducer.apiLoad(true));
      setPageSelected(pageNo);

      if (!isFilterIReset) {
        if (TargetColomn === "te_divisionstatus") {
          let status = Divfilter.toLowerCase();
          if (status === "active") {
            keyWord = "1";
          } else if (status === "inactive") {
            keyWord = "0";
          }
        }

        await axios
          .get(
            `division/list/?page=${pageNo}&limit=${listLimit}&${TargetColomn}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              setListDivision(response.data.data.rows);
            } else if (response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.apiLoad(false));
            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      } else if (isFilterIReset) {
        dispatch(sidebarReducer.apiLoad(true));
        if (dummyDivisionselData === "te_divisionstatus") {
          let status = dummyDivfilter.toLowerCase();
          if (status === "active") {
            keyWord = "1";
            // setDivfilter("1");
          } else if (status === "inactive") {
            keyWord = "0";
            // setDivfilter("0");
          }
        } else if (dummyDivisionselData !== "te_divisionstatus") {
          keyWord = dummyDivfilter;
        }

        await axios
          .get(
            `division/list/?page=${pageNo}&limit=${listLimit}&${dummyDivisionselData}=${keyWord}`,
            options
          )
          .then((response) => {
            if (response.status === 200) {
              dispatch(sidebarReducer.apiLoad(false));
              setListDivision(response.data.data.rows);
            }
            else if (response.status !== 200) {
              dispatch(sidebarReducer.apiLoad(false));
              dispatch(sidebarReducer.stringUpdate("AppDown"));
            }
          })
          .catch((err) => {
            dispatch(sidebarReducer.apiLoad(false));

            dispatch(sidebarReducer.stringUpdate("AppDown"));
          });
      }
    }
  };

  //Update Listingtable
  const responseData = async () => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`division/list?page=${pageSelected}&limit=${listLimit}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          let pages;
          response.data.data.count === 0
            ? (pages = 1)
            : (pages = Math.ceil(response.data.data.count / listLimit));
          setNoOfPages(pages);
          setDivisionCount(response.data.data.count);
          return setListDivision(response.data.data.rows);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  const BuResponse = async () => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`businessunit/listactive`, options)

      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          setBuData(response.data.data);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  const DivisionResponse = async (opt) => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`division/listactive/${opt}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          setdivisionData(divisionData); //V I
          setdivisionData(response.data.data);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  //Add Division API
  const newAddDivision_data = {
    name: newDivision,
    status: newStatus,
    buid: newId,
  };

  const onAdddivision = async (e) => {
    e.preventDefault();
    dispatch(sidebarReducer.apiLoad(true));

    await axios
      .post("division/add", newAddDivision_data, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          if (
            response.data.message ===
            `Division '${newAddDivision_data.name}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.success(true));
          }
          dispatch(divisionReducer.adddivision_IsPane(false));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));

        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
      });
  };

  //Update division API
  const newDivision_data = {
    name: divisionName,
    status: Editstatus,
    buid: businessunitData,
  };

  const onUpdate = async (te_divisionid) => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .put(`division/update/${te_divisionid}`, newDivision_data, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          if (
            response.data.message ===
            `Division '${newDivision_data.name}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.update_success(true));
          }
          dispatch(divisionReducer.division_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListDivision"));
          dispatch(divisionReducer.division_IsPane(false));
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        console.log(err, "errr");
        setErrMsg(err.response.data.data);
        // dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  //Delete user API
  const onDelete = async (division_id) => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .post(`division/delete/${division_id}`, [], options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(divisionReducer.division_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListDivision"));
          dispatch(divisionReducer.division_IsPane(false));
          responseData(division_Buid);

          dispatch(sidebarReducer.delete_success(true));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  //Select a division from the table to get the pop up

  async function onEdit(item) {
    await axios
      .get(`division/details/${item.te_divisionid}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          setIsDependent(response.data.data.dependency);

          setDivisionId(response.data.data.te_divisionid);
          setDivisionName(response.data.data.te_divisionname);
          setEditStatus(response.data.data.te_divisionstatus);
          setBusinessunitData(response.data.data.te_buid);
          setBusinessunitName(response.data.data.te_buname);

          if (response.data.data.te_divisionstatus === "1") {
            setStatusName("Active");
            setStatusName(statusName); //V I
          }
          if (response.data.data.te_divisionstatus === "0") {
            setStatusName("Inactive");
          }

          dispatch(
            divisionReducer.division_id(response.data.data.te_divisionid)
          );
          dispatch(
            divisionReducer.division_name(response.data.data.te_divisionname)
          );
          dispatch(
            divisionReducer.division_status(
              response.data.data.te_divisionstatus
            )
          );
          dispatch(divisionReducer.division_Buid(response.data.data.te_buid));
          dispatch(divisionReducer.division_IsPane(true));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }

  //Cancel button function
  const onCancel = async () => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`division/details/${division_id}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          setDivisionName(division_name);
          setEditStatus(response.data.data.te_divisionstatus);
          dispatch(divisionReducer.division_edit(false));
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  // useEffect hook
  useEffect(() => {
    if (View_Permission === 1) {
      responseData(opt);
      BuResponse();
    }
    return () => {};
    // eslint-disable-next-line
  }, []);

  const handleSearch = async (e, TargetColomn, keyWord) => {
    e.preventDefault();
    dispatch(sidebarReducer.apiLoad(true));

    if (TargetColomn === "te_divisionstatus") {
      let status = Divfilter.toLowerCase();
      if (status === "active") {
        keyWord = "1";
      } else if (status === "inactive") {
        keyWord = "0";
      }
    }
    await axios
      .get(
        `division/list/?limit=${listLimit}&${TargetColomn}=${keyWord}`,
        options
      )
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          setListDivision(response.data.data.rows);
          setDivisionCount(response.data.data.count);
          let pages;
          response.data.data.count === 0
            ? (pages = 1)
            : (pages = Math.ceil(response.data.data.count / listLimit));
          setNoOfPages(pages);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
        dispatch(sidebarReducer.apiLoad(false));
      });
  };

  //Clear button outside accordion
  const handleReset = () => {
    // e.preventDefault();
    dispatch(divisionReducer.division_filter(true));

    setDivfilter("");
    setDivisionselData("");


    setDummyDivfilter("");
    setDummyDivisionselData("");
    setIsFilterIReset(false);
    responseData(division_Buid);
  };
  //Clear button inside accordion

  const handleReset1 = (e) => {
    setDivfilter("");
    setDivisionselData("");
  };

  return (
    <div>
      {View_Permission === 1 ? (
        <div className="container-fluid">
          {/** total content part in the layout */}
          <div className="row">
            <div className="col-12 p-0" style={{ minHeight: "84.6vh" }}>
              <div className="row g-0 p-0">
                <div className="col">
                  <div
                    className=" g-0 m-0 border-top"
                    style={{ backgroundColor: "#f2f3f5" }}
                  >
                    <div className="row p-0 border-bottom">
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row">
                          <div className="p-2 mt-1">
                            <h5>
                              <strong>Divisions</strong>
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row-reverse me-3">
                          <div className="p-2">
                            <button
                              className="btn"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-expanded="false"
                              aria-controls="collapseOne"
                              style={{
                                backgroundColor: "var(--themes-color)",
                                color: "white",
                                minWidth: "160px",
                              }}
                              onClick={() => {
                                Add_Permission === 1 &&
                                  dispatch(
                                    divisionReducer.adddivision_IsPane(true)
                                  );
                                handleReset();
                              }}
                            >
                              <span
                                className="ToolTipU"
                                style={{
                                  backgroundColor: "var(--themes-color)",
                                }}
                              >
                                <i className="bi bi-plus-lg"></i>&nbsp; Add
                                Division
                                <span
                                  className="ToolTipTextU"
                                  style={{
                                    backgroundColor:
                                      Add_Permission === 1
                                        ? "var(--themes-color)"
                                        : "red",
                                  }}
                                >
                                  {Add_Permission === 1
                                    ? "You can add a Division."
                                    : "You cannot add a Division."}
                                </span>
                              </span>
                            </button>
                          </div>

                          {/* Filer button */}
                          <div className="dropdown  p-2">
                            {division_filter ? (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "77px",
                                }}
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                onClick={(e) => {
                                  // handleSearch(
                                  //   e,
                                  //   DivisionselData,
                                  //   Divfilter.toLowerCase());
                                  setTableHeight(true);
                                  dispatch(
                                    divisionReducer.division_filter(false)
                                  );
                                }}
                              >
                                <i className="bi bi-funnel-fill iconcolor"></i>
                                &nbsp; <span className="fw-normal">Filter</span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn px-2 "
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="false"
                                aria-controls="collapseOne"
                                style={{
                                  backgroundColor: "white",
                                  minWidth: "78px",
                                }}
                                onClick={() => {
                                  handleReset();
                                  setTableHeight(false);
                                  setIsFiltered(false);
                                }}
                              >
                                <i className="bi bi-funnel-fill  iconcolor"></i>
                                &nbsp;
                                <span className="fw-normal">Clear</span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row g-0 p-0">
                <div className="col">
                  <div className="container-fluid g-0">
                    {!division_IsPane && !adddivision_IsPane && (
                      <div className="accordion" id="accordionExample">
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div
                            className="row accordion-body d-flex align-items-end p-2 "
                            style={{
                              backgroundColor: "#E3F7F9",
                              height: "90px",
                            }}
                          >
                            <div className="container">
                              <div className="row justify content start">
                                <div
                                  className="col-3"
                                  style={{
                                    // backgroundColor: "red",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <TextField
                                    label="keyword"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      "& > :not(style)": {
                                        zIndex: "0",
                                      },
                                    }}
                                    value={Divfilter}
                                    onChange={(e) => {
                                      let val = e.target.value;
                                      setDivfilter(val);
                                      setDummyDivfilter(val);
                                    }}
                                  />
                                </div>

                                <div
                                  className="col-3"
                                  style={{
                                    // backgroundColor: "yellow",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <FormControl sx={{ width: "90%" }}>
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      style={{ zIndex: "0" }}
                                      size="small"
                                    >
                                      Target Column
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Target Columns"
                                      value={DivisionselData}
                                      size="small"
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        setDivisionselData(val);
                                        setDummyDivisionselData(val);
                                      }}
                                    >
                                      <MenuItem
                                        value="te_divisionname"
                                        size="small"
                                      >
                                        Division Name
                                      </MenuItem>
                                      <MenuItem value="te_buname" size="small">
                                        Business Unit
                                      </MenuItem>
                                      <MenuItem
                                        value="te_divisionstatus"
                                        size="small"
                                      >
                                        Status
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "blue",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white "
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={(e) => {
                                      handleSearch(
                                        e,
                                        DivisionselData,
                                        Divfilter
                                      );
                                      setIsFiltered(true);
                                      setIsFilterIReset(false);
                                      setPageSelected(1);
                                    }}
                                    disabled={
                                      Divfilter.length > 0 &&
                                      DivisionselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Filter
                                  </button>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "green",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={() => {
                                      handleReset1();
                                      // setIsFiltered(true);
                                      setIsFilterIReset(true);
                                    }}
                                    disabled={
                                      Divfilter.length > 0 &&
                                      DivisionselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/** ROW 2 for table */}
                    {tableHeight ? (
                      <div
                        className="table-wrapper-scroll-y my-custom-scrollbar"
                        style={{ minHeight: "60vh" }}
                      >
                        {apiLoad ? (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        ) : (
                          <table
                            className="table table-hover ListUserTable border"
                            style={{ cursor: "pointer" }}
                          >
                            <thead style={{ backgroundColor: "#ecedef" }}>
                              <tr style={{ textAlign: "left" }} e="true">
                                <th className="border">Sl.No</th>
                                <th className="border">Division Name</th>
                                <th className="border">Business Unit</th>
                                <th className="border">Status</th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "left" }}>
                              {ListDivision.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className=" border text-center mb-0"
                                  >
                                    {" "}
                                    No Data Found
                                  </td>
                                </tr>
                              ) : (
                                ListDivision.map((item, index) => (
                                  <tr
                                    key={index}
                                    onClick={() => {
                                      onEdit(item);
                                      handleReset();
                                    }}
                                    style={{
                                      cursor: "pointer",

                                      backgroundColor: `${
                                        item.te_divisionid === division_id &&
                                        division_IsPane === true
                                          ? " #f2f3f5"
                                          : " #fff"
                                      }`,
                                    }}
                                  >
                                    <td className="border text-start">
                                      {index +
                                        1 +
                                        listLimit * (pageSelected - 1)}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_divisionname}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_buname}
                                    </td>
                                    <td
                                      className="border text-start"
                                      style={{ textAlign: "left" }}
                                    >
                                      {item.te_divisionstatus === "0"
                                        ? "Inactive"
                                        : "Active"}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    ) : (
                      <div
                        className="table-wrapper-scroll-y my-custom-scrollbar"
                        style={{ minHeight: "90vh" }}
                      >
                        {apiLoad ? (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        ) : (
                          <table className="table table-hover ListUserTable border">
                            <thead style={{ backgroundColor: "#ecedef" }}>
                              <tr style={{ textAlign: "left" }} e="true">
                                <th className="border">Sl.No</th>
                                <th className="border">Division Name</th>
                                <th className="border">Business Unit</th>
                                <th className="border">Status</th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "left" }}>
                              {ListDivision.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className=" border text-center mb-0"
                                  >
                                    No Data Found
                                  </td>
                                </tr>
                              ) : (
                                ListDivision.map((item, index) => (
                                  <tr
                                    key={index}
                                    onClick={() => {
                                      onEdit(item);
                                      //handleReset();
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      backgroundColor: `${
                                        item.te_divisionid === division_id &&
                                        division_IsPane === true
                                          ? " #f2f3f5"
                                          : " #fff"
                                      }`,
                                    }}
                                  >
                                    <td className="border text-start">
                                      {index +
                                        1 +
                                        listLimit * (pageSelected - 1)}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_divisionname}
                                    </td>
                                    <td className="border text-start">
                                      {item.te_buname}
                                    </td>
                                    <td
                                      className="border text-start"
                                      style={{ textAlign: "left" }}
                                    >
                                      {item.te_divisionstatus === "0"
                                        ? "Inactive"
                                        : "Active"}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* pagination footer */}
            {!apiLoad && (
              <div className="container">
                <div className="row main-footer">
                  <div className="col-3 mt-2" style={{ whiteSpace: "nowrap" }}>
                    Total Records: {divisionCount}
                  </div>
                  <div className="col-4 mt-2">
                    <div className="d-flex justify-content-center ">
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-double-left"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            leftEndArrow();
                          }}
                        ></i>
                      </div>
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-left"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            pageSelected !== 1 && leftArrow();
                          }}
                        ></i>
                      </div>
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index1_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index1_pagenation,
                            DivisionselData,
                            Divfilter
                          );
                        }}
                      >
                        {index1_pagenation}
                      </div>
                      {noOfPages > 1 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index2_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index2_pagenation,
                              DivisionselData,
                              Divfilter
                            );
                          }}
                        >
                          {index2_pagenation}
                        </div>
                      )}
                      {noOfPages > 2 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index3_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index3_pagenation,
                              DivisionselData,
                              Divfilter
                            );
                          }}
                        >
                          {index3_pagenation}
                        </div>
                      )}
                      {noOfPages > 3 && (
                        <div
                          className={
                            noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                          }
                          style={
                            index4_pagenation === pageSelected
                              ? onPage
                              : notOnPage
                          }
                          onClick={() => {
                            pagenationAPi(
                              index4_pagenation,
                              DivisionselData,
                              Divfilter
                            );
                          }}
                        >
                          {index4_pagenation}
                        </div>
                      )}
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-right"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            pageSelected !== noOfPages && rightArrow();
                          }}
                        ></i>
                      </div>
                      <div className={noOfPages > 4 ? "" : ""}>
                        <i
                          className="bi bi-chevron-double-right"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            rightEndArrow();
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-3 mt-2 ">
                    <div className="d-flex justify-content-end me-3">
                      <span>
                        <strong>Page {pageSelected} </strong> of{" "}
                        <strong>{noOfPages}</strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/** SlidingPan pop up for selecting and editing user data */}
          {
            <SlidingPane
              className="some-custom-class"
              overlayClassName="some-custom-overlay-class"
              width="71%"
              hideHeader
              isOpen={division_IsPane}
              onRequestClose={() => {
                // triggered on "<" on left top click or on outside click
                onCancel();
              }}
            >
              <div
                className="container-fluid  "
                style={{ backgroundColor: "#f2f3f5", height: "54px" }}
              >
                <div className="row" style={{ height: "54px" }}>
                  <div className="col-3">
                    <div className="d-flex align-items-center ">
                      <div
                        className="px-1 pt-1"
                        onClick={() => {
                          dispatch(divisionReducer.division_edit(false));
                          dispatch(sidebarReducer.stringUpdate("ListDivision"));
                          dispatch(divisionReducer.division_IsPane(false));
                          setErrMsg("");
                        }}
                      >
                        <i className="bi bi-arrow-right"></i>
                      </div>
                      <div
                        className="border-start"
                        // className="px-2 pt-3 pb-1 border-secondary border-opacity-25 border-start"
                        style={{ height: "54px" }}
                      >
                        <h5 className="px-1 pt-3">
                          <strong>{division_name}</strong>
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-9" style={{ height: "54px" }}>
                    <div
                      className="d-flex flex-row-reverse bd-highlight"
                      style={{ height: "54px" }}
                    >
                      <div
                        className="p-0 border-start"
                        // style={{ backgroundColor: "red" }}
                      >
                        {division_edit ? (
                          <button
                            className="button"
                            style={{
                              // paddingTop: "3px",
                              border: "none",
                              height: "54px",
                            }}
                            onClick={() => onUpdate(divisionId)}
                          >
                            <i className="bi bi-file-earmark-diff-fill"></i>
                            &nbsp;Save Changes
                          </button>
                        ) : (
                          <div>
                            <button
                              className="button"
                              style={{
                                zIndex: "1100",
                                // paddingTop: "3px",
                                border: "none",
                                height: "54px",
                              }}
                              onClick={() =>
                                Edit_Permission === 1 &&
                                dispatch(
                                  divisionReducer.division_edit(!division_edit)
                                )
                              }
                            >
                              <span
                                className="ToolTipPEdit"
                                // style={{
                                //   backgroundColor: "var(--themes-color)",
                                // }}
                              >
                                <i className="bi bi-pencil-fill"></i>&nbsp; Edit
                                Record
                                <span
                                  className="ToolTipTextPEdit"
                                  style={{
                                    backgroundColor:
                                      Edit_Permission === 1
                                        ? "var(--themes-color)"
                                        : "red",
                                  }}
                                >
                                  {Edit_Permission === 1
                                    ? "You can edit the Division."
                                    : "You cannot edit the Division."}
                                </span>
                              </span>
                            </button>
                          </div>
                        )}
                      </div>
                      {division_edit && (
                        <div
                          className=" border-start "
                          style={{ height: "54px" }}
                          onClick={() => {
                            setPopUp(false);
                            onCancel();
                          }}
                        >
                          <button
                            className="button"
                            style={{
                              // paddingTop: "3px",
                              border: "none",
                              height: "54px",
                              minWidth: "85px",
                            }}
                          >
                            <i className="bi bi-arrow-clockwise"></i>
                            &nbsp;Cancel Changes
                          </button>
                        </div>
                      )}
                      <div className="p-0 border-start">
                        <button
                          className="button"
                          // data-bs-toggle="modal"
                          data-bs-target="#DeleteUser"
                          // data-backdrop="false"
                          style={{
                            zIndex: "1100",
                            border: "none",
                            height: "54px",
                            minWidth: "85px",
                          }}
                          onClick={() => {
                            Delete_Permission === 1 && setPopUp(true);
                          }}
                        >
                          <span
                            className="ToolTipPEdit"
                            style={
                              {
                                // backgroundColor:
                                //   "var(--themes-color)"
                              }
                            }
                          >
                            <i className="bi bi-trash-fill"></i>&nbsp; Delete
                            record
                            <span
                              className="ToolTipTextPEdit"
                              style={{
                                backgroundColor:
                                  Delete_Permission === 1
                                    ? "var(--themes-color)"
                                    : "red",
                              }}
                            >
                              {Delete_Permission === 1
                                ? "You can delete the Division."
                                : "You cannot delete the Division."}
                            </span>
                          </span>
                        </button>
                      </div>
                      <div className="mode" style={{ padding: "14px" }}>
                        <div className="d-flex justify-content-center">
                          <i>
                            <strong style={{ color: "blue" }}>
                              {division_edit ? "Edit Mode" : "View Mode"}
                            </strong>
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row contentscroll" style={{ width: "101.1%" }}>
                <div className="col ms-3 mt-2">
                  {/* <h5>Basic information:</h5> */}
                  <form style={{ width: "99%" }}>
                    <div className="mb-3">
                      <TextField
                        type="text"
                        className="form-control mt-2"
                        id="formGroupExampleInput"
                        label="Name"
                        size="small"
                        value={divisionName}
                        variant="outlined"
                        onChange={(e) => setDivisionName(e.target.value)}
                        disabled={division_edit ? false : true}
                      />
                    </div>
                    <div
                      className="mb-3"
                      onMouseDown={() => {
                        if (division_edit) setBusinessunitName("Business Unit");
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                          {businessunitName}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          disabled={division_edit ? false : true}
                          label="business unit"
                          variant="outlined"
                          onChange={(e) => {
                            let val = e.target.value;
                            setBusinessunitData(e.target.value);
                            DivisionResponse(val);
                          }}
                        >
                          {buData.map((item, index) => (
                            <MenuItem key={index} value={item.te_buid}>
                              {item.te_buname}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      onMouseDown={() => {
                        if (division_edit) setStatusName("Status");
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                          {/* {statusName} */}
                          Status
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          disabled={division_edit ? false : true}
                          label="inactiv"
                          value={Editstatus}
                          variant="outlined"
                          onChange={(e) => {
                            setEditStatus(e.target.value);
                            setStatusName("Status");
                          }}
                        >
                          <MenuItem value="1"> Active</MenuItem>
                          <MenuItem value="0"> Inactive</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div></div>
                    <br />
                    <br />
                    <div className="d-flex justify-content-center">
                      <div className="p-2"></div>
                      <strong>
                        <span style={{ color: "red" }}> {errMsg}</span>
                      </strong>
                    </div>
                  </form>
                </div>
              </div>
            </SlidingPane>
          }

          {/** SlidingPan pop up for adding new division data */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="71%"
            hideHeader
            isOpen={adddivision_IsPane}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              // onCancel();
            }}
          >
            <div
              className="container-fluid m-0 g-0 border"
              style={{ backgroundColor: "#f2f3f5" }}
            >
              <div className="col-3">
                <div className="d-flex align-items-center flex-row">
                  <div
                    className="px-2 my-1"
                    onClick={() => {
                      dispatch(sidebarReducer.stringUpdate("ListDivision"));
                      dispatch(divisionReducer.adddivision_IsPane(false));
                    }}
                  >
                    <i className="bi bi-arrow-right"></i>
                  </div>
                  <div className="px-2 pt-2 pb-1 border-secondary border-opacity-25 border-start">
                    <h5 style={{ whiteSpace: "nowrap" }}>
                      <strong>Add Division</strong>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-9"></div>
            </div>

            <div className="row contentscroll" style={{ width: "101.5%" }}>
              <div className="col ms-3 mt-2">
                <form onSubmit={onAdddivision} style={{ width: "99%" }}>
                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control mt-2"
                      id="formGroupExampleInput"
                      size="small"
                      label="Name"
                      variant="outlined"
                      required
                      onChange={(e) => setNewDivision(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        size="small"
                        required
                      >
                        Business Unit
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        size="small"
                        label="Business Unit"
                        variant="outlined"
                        required
                        onChange={(e) => {
                          let val = e.target.value;
                          setNewId(val);
                        }}
                      >
                        {buData.map((item, index) => (
                          <MenuItem key={index} value={item.te_buid}>
                            {item.te_buname}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="mb-3">
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        size="small"
                        required
                      >
                        Status
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        size="small"
                        label="inactiv"
                        variant="outlined"
                        required
                        onChange={(e) => {
                          let val = e.target.value;
                          setNewStatus(val);
                        }}
                      >
                        <MenuItem value={"1"}>Active</MenuItem>
                        <MenuItem value={"0"}>Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div className="">
                    <button
                      className="btn btn-light text-white"
                      type="submit"
                      style={{ backgroundColor: "var(--themes-color)" }}
                    >
                      &nbsp;Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </SlidingPane>
          <Modal
            open={popUp}
            // onClose={}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <center>
                <div
                  style={{
                    overflowY: "auto",
                  }}
                >
                  <h6>
                    {IsDependent
                      ? " This Division has dependency, Cannot delete this Division"
                      : "Are you sure you want to delete this Division?"}
                  </h6>
                </div>

                <div className="pt-4">
                  {!IsDependent && (
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      style={{
                        // backgroundColor: "var(--themes-color)",
                        width: "100px",
                      }}
                      onClick={() => {
                        setPopUp(false);
                        onDelete(divisionId);
                      }}
                    >
                      Delete
                    </button>
                  )}
                  &nbsp; &nbsp; &nbsp;
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      // backgroundColor: "var(--themes-color)",
                      width: "100px",
                    }}
                    onClick={() => {
                      setPopUp(false);
                    }}
                  >
                    Close
                  </button>
                </div>
              </center>
            </Box>
          </Modal>

          {/* <div className="backdrop">
            <Backdrop
              sx={{
                color: "var(--themes-color)",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={apiLoad}
            //onClick={handleClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div> */}

          <SuccessAlert />
          <FailureAlert />
          <InformationAlert />
          <SuccessUpdate />
          <FailureUpdate />
          <SuccessDelete />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          <h3>You do not have permission to view this page.</h3>
        </div>
      )}
    </div>
  );
}

export default ListDivision;
